import React from 'react';
import {observer} from 'mobx-react';

import {usePromotions} from '../../queries/promotions';
import {useStores} from '../../stores/use-stores';

import PromotionsListScreenBase from './PromotionsListScreenBase';

const PromotionsListScreen = observer(() => {
  const {shopSelectionStore} = useStores();
  const {promotions, listedECommerceOnlyPromotions} = usePromotions();

  let activations = promotions;
  if (shopSelectionStore.canPickup || shopSelectionStore.canDeliver) {
    activations = [...activations, ...listedECommerceOnlyPromotions];
  }

  return <PromotionsListScreenBase promotions={activations} />;
});

export default PromotionsListScreen;
